module.exports = __webpack_public_path__ + "static/media/administration.524cbb09.svg";